module.exports = __webpack_public_path__ + "img/biaoqian_huitang.bad7312b.png";